import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const HeaderMinimal = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: t('nav.work'), href: '#work', isRoute: false },
    { name: t('nav.about'), href: '#about', isRoute: false },
    { name: t('nav.services'), href: '#services', isRoute: false },
    { name: t('nav.contact'), href: '#contact', isRoute: false },
    { name: t('nav.blog'), href: '/blog', isRoute: true }
  ];

  const handleNavClick = (e, link) => {
    if (link.isRoute) {
      // Navigate to route (like /blog)
      navigate(link.href);
    } else {
      // Scroll to section
      e.preventDefault();
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const element = document.querySelector(link.href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        const element = document.querySelector(link.href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <header className={`sticky top-0 z-50 w-full bg-black/80 backdrop-blur-sm transition-all duration-200 ${isScrolled ? 'border-b border-tertiary' : ''}`}>
      <nav className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex items-center justify-between">
        {/* Logo */}
        <a 
          href="/" 
          className="font-serif-italic text-xl text-gold hover:opacity-60 transition-opacity"
        >
          Aryan Shivhare
        </a>

        {/* Navigation Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => handleNavClick(e, link)}
              className="text-sm text-secondary hover:text-gold transition-colors font-sans"
            >
              {link.name}
            </a>
          ))}
          
          {/* CTA Link */}
          <a
            href="#contact"
            onClick={(e) => handleNavClick(e, { href: '#contact', isRoute: false })}
            className="text-sm text-gold underline underline-offset-4 hover:opacity-60 transition-opacity font-sans font-medium"
          >
            {t('nav.getInTouch')}
          </a>
          
          {/* Language Switcher */}
          <LanguageSwitcher />
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-gold">
          <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>
      </nav>
    </header>
  );
};

export default HeaderMinimal;
